import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  cacheMap = new Map<any, any>(null);
  constructor() { /* empty */ }

  getFromCache(req: HttpRequest<any>): any {
    const url = req.urlWithParams;
    const cache = this.cacheMap.get(url);

    if (!cache) return undefined;

    return this.cacheMap.get(url).response;
  }

  addToCache(req: HttpRequest<any>, response: HttpResponse<any>) {
    const url = req.urlWithParams;
    const entry = { url, response, addedTime: Date.now() };
    this.cacheMap.set(url, entry);
  }
}
